import React from "react";
const Authorization = (WrappedComponent, allowedRoles, user) => {
  return class WithAuthorization extends React.Component {
    constructor(props) {
      super(props);
    }
    render() {
      const { role } = user;
      if (allowedRoles.includes(role)) {
        return <WrappedComponent {...this.props} />;
      } else {
        window.location.href = "/afgreidsla";
        return <h1>...</h1>;
      }
    }
  };
};

export default Authorization;


// WEBPACK FOOTER //
// ./src/Authorization.jsx